import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getHero } from '../services/api';
import '../styles/Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  const [heroData, setHeroData] = useState({
    title: 'Architectural Excellence',
    subtitle: 'Creating spaces that inspire and endure',
    cta_text: 'View Projects',
    background_image: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHeroData();
  }, []);

  const fetchHeroData = async () => {
  try {
    const response = await getHero();
    if (response && response.data) {
      setHeroData(response.data);  // ← هنا التغيير!
    }
  } catch (error) {
    console.error('Error fetching hero data:', error);
  } finally {
    setLoading(false);
  }
};

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (loading) {
    return <div className="hero-loading">{t('hero.loading')}</div>;
  }

  return (
    <section
      id="home"
      className="hero"
      style={{
        backgroundImage: heroData.background_image
          ? `url(${process.env.REACT_APP_API_URL}${heroData.background_image})`
          : 'linear-gradient(135deg, #000000ff 0%rgba(180, 180, 180, 1)a2 100%)'
      }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title" data-aos="fade-up">
          {heroData.title}
        </h1>
        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
          {heroData.subtitle}
        </p>
        <button 
          className="hero-cta" 
          onClick={scrollToProjects}
          data-aos="fade-up" 
          data-aos-delay="400"
        >
          {heroData.cta_text}
        </button>
      </div>
      <div className="hero-scroll-indicator">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;